<script>
	import CustomCollapseCard from "src/components/CustomCollapseCard/CustomCollapseCard.svelte";
	import { convert } from "src/services/helpers";
	import { isOperatorCaseOrigin, isPhase3CaseOrigin } from "src/utils/misc";
	import { Col, Row } from "@sveltestrap/sveltestrap";

	export let caseDetails = {};
</script>

{#if caseDetails.createdFrom === "Desmond" || isPhase3CaseOrigin(caseDetails.createdFrom) || isPhase3CaseOrigin(caseDetails.caseOrigin)}
	<CustomCollapseCard
		customClass="mb-4"
		title="Investigator Information"
		isOpenDefault={true}
	>
		<div class="p-0">
			<Row>
				<Col xs={4}>
					<div class="description">Investigator Name</div>
					<div class="value">
						{caseDetails.investigatorName || "-"}
					</div>
				</Col>
				<Col xs={4}>
					<div class="description">Report Reviewed Date</div>
					<div class="value">
						{convert(caseDetails.updatedAt) || "-"}
					</div>
				</Col>
			</Row>
		</div>
	</CustomCollapseCard>
{/if}
